/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

export const SUPPORTED_LANGUAGES = [
    {
        code: 'en',
        name: 'English',
    },
    {
        code: 'zh',
        name: '中文 (Chinese)',
    },
]

export const LIST_ORDER = {
    ASC: 'ASC',
    DESC: 'DESC',
}